import { __awaiter, __generator } from "tslib";
import { decrypt, encrypt } from '@office-start/encryption-utility';
import { utf8Decode, utf8Encode } from '@office-start/text-encoding-utility';
export function createEncryptionPlugin(key) {
    var _this = this;
    return {
        onBeforeWriteValue: function (value) { return __awaiter(_this, void 0, void 0, function () {
            var buffer, payloadType, encodedBytes, encryptedBuffer, item;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!value) {
                            return [2 /*return*/, value];
                        }
                        if (!(value instanceof ArrayBuffer)) return [3 /*break*/, 1];
                        buffer = value;
                        payloadType = 'rawbytes';
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, utf8Encode(JSON.stringify(value))];
                    case 2:
                        encodedBytes = _a.sent();
                        buffer = encodedBytes.buffer;
                        payloadType = 'utf8-encoded-string';
                        _a.label = 3;
                    case 3: return [4 /*yield*/, encrypt(buffer, key)];
                    case 4:
                        encryptedBuffer = _a.sent();
                        item = {
                            buffer: encryptedBuffer,
                            payloadType: payloadType,
                        };
                        return [2 /*return*/, item];
                }
            });
        }); },
        onAfterReadValue: function (value) { return __awaiter(_this, void 0, void 0, function () {
            var decryptedBuffer, decodedString;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!value) {
                            return [2 /*return*/, value];
                        }
                        return [4 /*yield*/, decrypt(new Uint8Array(value.buffer), key)];
                    case 1:
                        decryptedBuffer = _a.sent();
                        if (!(value.payloadType === 'rawbytes')) return [3 /*break*/, 2];
                        return [2 /*return*/, decryptedBuffer];
                    case 2: return [4 /*yield*/, utf8Decode(new Uint8Array(decryptedBuffer))];
                    case 3:
                        decodedString = _a.sent();
                        return [2 /*return*/, JSON.parse(decodedString)];
                }
            });
        }); },
    };
}
//# sourceMappingURL=EncryptionPlugin.js.map